<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>CMDB Management</h1>
        <p class="text-muted">Manage CMDB synchronization</p>

        <div style="padding-top: 20px;">
          <modernization-cmdb-sync />
        </div>
      </div>
    </div>
  </section>
</main>
